export const SET_SELECTED_ROWS = "SET_SELECTED_ROWS";
